import { skipToken } from "@reduxjs/toolkit/query";
import { useSelector } from "react-redux";

import { selectProfileSSOid } from "../../app-main/selectors/profile.selectors";
import type { OwnerListing } from "../../services/listings.service";
import { useGetOwnerListingsQuery } from "../../services/listings.service";

type UseHostHubOwnerListingsResult = {
  isError: boolean;
  isLoading: boolean;
  listings: OwnerListing[] | undefined;
};

/**
 * Shared accessor for the authenticated host's listings (titles, use types,
 * images, instant-book flags) from `GET /v2/spaces-v2/listings/owner/:sso-id`.
 * Recommendation hooks consume this so the owner-listings fetch is declared
 * once and reused via RTK Query's cache.
 */
const useHostHubOwnerListings = (): UseHostHubOwnerListingsResult => {
  const ssoId = useSelector(selectProfileSSOid);

  const ownerListingsQuery = useGetOwnerListingsQuery(
    ssoId ? { ssoId } : skipToken,
  );

  return {
    isError: ownerListingsQuery.isError,
    isLoading: ownerListingsQuery.isLoading,
    listings: ownerListingsQuery.data?.listings,
  };
};

export default useHostHubOwnerListings;
